import { DOCUMENT } from '@angular/common';
import { Component, inject, OnInit } from '@angular/core';
import { TranslatePipe, TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-terms-and-conditions',
  standalone: true,
  imports: [TranslatePipe],
  templateUrl: './terms-and-conditions.component.html',
  styleUrl: './terms-and-conditions.component.scss'
})
export class TermsAndConditionsComponent implements OnInit {
  private readonly document = inject(DOCUMENT);
  private readonly translateService = inject(TranslateService);

  readonly pdfUrl = new URL(`assets/pdf/${this.documentLanguage()}_UniGanaTCs.pdf#view=FitH`, this.document.baseURI)
    .href;

  ngOnInit(): void {
    // Use the browser's PDF viewer to avoid the clipped, unzoomable iframe reported on iOS.
    this.document.location.replace(this.pdfUrl);
  }

  private documentLanguage(): 'en' | 'es' {
    const language = this.translateService.getCurrentLang() || this.translateService.getFallbackLang() || 'es';
    return language.toLowerCase().startsWith('en') ? 'en' : 'es';
  }
}
